/* eslint-disable max-len */
/* eslint-disable no-unused-expressions */
import { classNames } from 'shared/lib/classNames/classNames';
import { ReactNode, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBackground } from 'features/StepInfo/modal/selectors/getStepInfo/getStepInfo';
import { stepActions } from 'features/StepInfo';
import cls from './Layout.module.scss';

interface LayoutProps {
    className?: string
    headerSlot?: ReactNode
    pageSlot: ReactNode
}

export const Layout = ({ className, headerSlot, pageSlot }: LayoutProps) => {
    console.log(headerSlot, 'header slot 77777')
    return (
        <div
            className={classNames(cls.Layout)}
        >
            {headerSlot && headerSlot}
            <div className={cls.content}>
                {pageSlot}
            </div>
        </div>
    );
}
